import { Api } from "src/utils/api";
import { MATH_BASE_URL } from "./mathUrl";
import { WIDGET_METRIC_KEYS } from "./math.const";

export type WidgetMetrics = Record<(typeof WIDGET_METRIC_KEYS)[number], number>;

export type WidgetMetricKey = keyof WidgetMetrics;

export class MathService extends Api {
  public static instance: MathService;

  public constructor() {
    super(MATH_BASE_URL);
  }

  private static getInstance(): MathService {
    if (!MathService.instance) {
      MathService.instance = new MathService();
    }
    return MathService.instance;
  }

  public async getAllMetrics(
    date_start: string,
    date_end: string,
  ): Promise<Partial<WidgetMetrics>> {
    return {};
  }

  // public static async getTotalSales(
  //   date_start: string,
  //   date_end: string,
  // ): Promise<number> {
  //   const data: number = await MathService.getInstance().get(
  //     "/sales-performance/total-sales",
  //     {
  //       date_start,
  //       date_end,
  //     },
  //   );

  //   useMathStore.getState().setSalesTotal(data);
  // }
}
